import { css } from '@emotion/react';
import { useContext } from 'react';
import MentoringProgramContext from 'athena/components/mentoring-program/context';
import { MentoringProgramRole } from 'redux/schemas/models/mentoring-program-enrollments';
import { MentoringProgramGuideRole } from 'redux/schemas/models/mentoring-program-guides';
import ParticipantDotAlias from '../../program-configuration/program-profile-setup/program-level/program-level-list/program-level-field/participant-dot-alias';
import { CellProps } from '.';


const AudienceCell = ({
  className,
  cell,
}: CellProps) => {
  const styles = css`
    // TODO: This seems like I shouldn't need to do this (i.e. it should be a universal class)
    .gap-2 {
      gap: 1rem;
    }
  `;

  const { mentoringProgram } = useContext(MentoringProgramContext);
  const { programAlias } = mentoringProgram || {};
  const { mentee, mentor } = programAlias || {};

  const role = cell.getValue();

  const isDeliveredToMentee = role === MentoringProgramGuideRole.MENTEE || role === MentoringProgramGuideRole.MENTOR_AND_MENTEE;
  const isDeliveredToMentor = role === MentoringProgramGuideRole.MENTOR || role === MentoringProgramGuideRole.MENTOR_AND_MENTEE;

  return (
    <div css={styles} className={`d-flex align-items-center ${className}`}>
      <div className='d-flex gap-2 pb-1'>
        {isDeliveredToMentee && (
          <ParticipantDotAlias
            alias={mentee.singularizedTitleized}
            role={MentoringProgramRole.MENTORSHIP_PROGRAM_MENTEE}
            className='pt-1'
          />
        )}
        {isDeliveredToMentor && (
          <ParticipantDotAlias
            alias={mentor.singularizedTitleized}
            role={MentoringProgramRole.MENTORSHIP_PROGRAM_MENTOR}
            className='pt-1'
          />
        )}
      </div>
    </div>
  );
};

export default AudienceCell;
